import moment from 'moment';
import * as _ from 'underscore';

import React, { Component } from 'react';

import ReactInfiniteCalendar from 'react-infinite-calendar';

import Console from '../../../../lib/debug';

class InfiniteCalendar extends Component {
    shouldComponentUpdate(nextProps) {
        return (
            nextProps.sessionCount !== this.props.sessionCount ||
            nextProps.date !== this.props.date
        );
    }

    render() {
        Console.render('InfiniteCalendar');
        const calTheme = {
            weekdayColor: '#fff',
            selectionColor: '#fff',
            textColor: {
                active: '#797c7f',
                default: '#333'
            }
        };

        const scroll = _.debounce(this.props.handleScroll, 400);
        const selected = moment(this.props.currentDay, 'YYYY_M_D').toDate();
        const weekStartsOn = this.props.trainingWeekStartsOnMonday ? 1 : 0;
        return (
            <div className="toc-cal">
                <ReactInfiniteCalendar
                    width={300}
                    height={180}
                    rowHeight={42}
                    displayOptions={{ showHeader: false }}
                    theme={calTheme}
                    selected={selected}
                    dotsItems={this.props.sessionsForCalendar}
                    enableScheduled={this.props.isPubEnabled}
                    onSelect={this.props.navigate}
                    onEnter={this.props.handleEnter}
                    onLeave={this.props.handleLeave}
                    onScroll={scroll}
                    locale={{ weekStartsOn: weekStartsOn }}
                />
            </div>
        );
    }
}

export default InfiniteCalendar;



// WEBPACK FOOTER //
// ./src/view/designer/components/InfinityCalendar/InfiniteCalendar.jsx